import { createTheme } from '@mui/material/styles';

export const tooltipTheme = createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '12px',
                },
            },
        },
    },
});
